import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { email, form, FormField, FormRoot, required, SchemaPathTree } from '@angular/forms/signals';
import { Tab, TabContent, TabList, TabPanel, Tabs } from '@angular/aria/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { PortalType } from 'src/app/shared/model/IWebConfig';
import { PhoneNumberInputComponent } from 'src/app/shared/components/phone-number-input/phone-number-input.component';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { LoginIdentityChange, LoginIdentityFormModel } from './login-identity.model';

@Component({
  selector: 'app-login-identity',
  templateUrl: './login-identity.component.html',
  styleUrls: ['./login-identity.component.scss'],
  imports: [
    NgTemplateOutlet,
    TranslatePipe,
    PhoneNumberInputComponent,
    FormField,
    FormRoot,
    FormFieldOnErrorDirective,
    Tab,
    TabContent,
    TabList,
    TabPanel,
    Tabs,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoginIdentityComponent {
  public portal = input<PortalType>();
  public portalId = input<string>();
  public loginMethod = input<string[]>([]);
  public identityChange = output<LoginIdentityChange>();

  public active = signal(1);
  public separateDialCode = false;
  public preferredCountries: string[] = ['za', 'gb', 'us'];

  formModel = signal<LoginIdentityFormModel>({ email: '', mobile: null });
  form = form(this.formModel, this.#formValidation.bind(this));

  constructor() {
    effect(() => {
      const model = this.formModel();
      this.identityChange.emit({
        active: this.active(),
        email: model.email,
        mobile: model.mobile,
        valid: !this.form().invalid(),
      });
    });
  }

  public tabChange(tabId: number): void {
    this.active.set(tabId);
    this.formModel.set({ email: '', mobile: null });
    this.form().markAsTouched();
  }

  #formValidation(path: SchemaPathTree<LoginIdentityFormModel>): void {
    required(path.email, { when: () => this.active() === 1 });
    email(path.email, { when: () => this.active() === 1 });
    required(path.mobile, { when: () => this.active() === 2 });
  }
}
